/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Payment_DescriptionInputs */

const de_billing_payment_description = /** @type {(inputs: Billing_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Zahlungsmethode verwenden wir für Ihr waipu.tv-Abo.`)
};

/** @type {(inputs: Billing_Payment_DescriptionInputs) => LocalizedString} */
const en_billing_payment_description = de_billing_payment_description;

/**

* @param {Billing_Payment_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_payment_description = /** @type {((inputs?: Billing_Payment_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Payment_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_billing_payment_description(inputs)
	return en_billing_payment_description(inputs)
});